import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CuadroDialogoComponent } from 'app/componentes/cuadro-dialogo/cuadro-dialogo.component';
import { MatDialogComponent } from 'app/componentes/mat-dialog/mat-dialog.component';
import { CertificadoService } from 'app/services/certificaciones/certificados.services';
import { DocumentService } from 'app/services/documentos.service';
import { DataService } from 'app/services/secciones.service';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-certificado-detalle',
  templateUrl: './certificado-detalle.component.html',
  styleUrls: ['./certificado-detalle.component.scss']
})
export class CertificadoDetalleComponent implements OnInit {


  obtenerId = () => this.activatedRoute.snapshot.params;
  //OBTENEMOS EL ID DE LA SEDE QUE EL USUARIO SELECCIONO 
  idCertificacion: string = this.obtenerId().idCertificacion;

  //VARIABLES
  edit: boolean = false;
  IMAGEN_HOST = environment.API_IMAGEN;
  imagen: any = '';

  //DECLARACIÓN DE FORMULARIOS REACTIVOS 
  CertificadoForm = new FormGroup({

    nombre: new FormControl('', Validators.required),
    descripcion: new FormControl('', Validators.required),
    rutaImagen: new FormControl('', Validators.required),
    orden: new FormControl(1),
    estado: new FormControl(1)

  });

  array: any = [];

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    public navigation: DataService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private serviciocertificado: CertificadoService,
    private serviciodocumento: DocumentService
  ) { }

  ngOnInit(): void {
    if (this.idCertificacion) {
      this.serviciocertificado.getCertficado(this.idCertificacion).subscribe(response => {
        this.CertificadoForm.patchValue(response[0])
        this.imagen = response[0].rutaImagen;

      });
    }
  }

  //VERIFICAMOS SI EL USUARIO VA A SALIR DE LA RUTA  CON DATOS EN EL FORMULARIO
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.CertificadoForm.dirty) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          message: ' ¿ Desea salir sin guardar los cambios ? ',
          buttonText: {
            ok: 'Aceptar',
            cancel: 'Cancelar'
          }
        }
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }

  //AVISO TIPO SNACKBAR ANGULAR MATERIAL
  openSnackBar(message: string) {
    this.snackBar.open(message, "Aceptar", { duration: 2000 });
  }

  guardarDatos = () => {

    let datos: any = []
    let imagen = this.CertificadoForm.get('rutaImagen').value;

    if (this.CertificadoForm.get('rutaImagen').value) {
      this.CertificadoForm.controls['rutaImagen'].setValue(imagen._fileNames)
    }

    this.serviciocertificado.getCertificados().subscribe(response => {
      datos = response;      
      if (response) {
        this.CertificadoForm.controls['orden'].setValue(datos.length + 1)
        this.serviciocertificado.crearCertficado(this.CertificadoForm.value).subscribe(response => {

          if (this.CertificadoForm.get('rutaImagen').value) {
            this.guardarImagenPHP(imagen)
          }

          this.CertificadoForm.markAsPristine()
          this.CertificadoForm.markAllAsTouched()
          this.openSnackBar("REGISTRO CREADO CORRECTAMENTE!")
          this.router.navigateByUrl('/certificados')
        });
      }
    })



  }

  actualizarDatos = () => {
    let imagen = this.CertificadoForm.get('rutaImagen').value;

    if (this.CertificadoForm.get('rutaImagen').value) {
      this.CertificadoForm.controls['rutaImagen'].setValue(imagen._fileNames)
    }

    this.serviciocertificado.actualizarCertficado(this.idCertificacion, this.CertificadoForm.value).subscribe(response => {
      if (this.CertificadoForm.get('rutaImagen').value) {
        this.guardarImagenPHP(imagen)
      }
      this.CertificadoForm.markAsPristine()
      this.CertificadoForm.markAllAsTouched()
      this.openSnackBar("INFORMACIÓN ACTUALIZADA!")
      this.router.navigateByUrl('/certificados')
    });
  }

  guardarImagenPHP = (imagen: any) => {

    this.CertificadoForm.controls['rutaImagen'].setValue(imagen._files[0]);
    const imgData = new FormData();
    imgData.append('imagen', this.CertificadoForm.get('rutaImagen').value);
    this.serviciodocumento.guardarImg(imgData).subscribe(response => {
    });

  }

  eliminarImagen = () => {

    this.dialog.open(CuadroDialogoComponent).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.serviciocertificado.actualizarEstadoImagen(this.idCertificacion, this.CertificadoForm.value).subscribe(response => {
          this.serviciodocumento.eliminarImagen(this.imagen).subscribe(response => {

          });
          this.openSnackBar("SE HA ELIMINADO CORRECTAMENTE")
          this.ngOnInit()
        })
      }
    })
  }


}
